import { SEGMENT_TAB, TAB_PARAM, type SegmentTab } from "./constants";

import { URL_PARAMS } from "@/constants/urlParams";

export const getSegmentTab = (params: URLSearchParams): SegmentTab =>
  Object.values(SEGMENT_TAB).find((tab) => tab === params.get(TAB_PARAM)) ?? SEGMENT_TAB.RULES;

export function withSegmentTab(params: URLSearchParams, tab: string): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete(URL_PARAMS.PAGE);
  if (tab === SEGMENT_TAB.RULES) {
    next.delete(TAB_PARAM);
  } else {
    next.set(TAB_PARAM, tab);
  }
  return next;
}
